import { Flex, Typography } from "antd"
import React from "react"

import { budgetFormat } from "../../../../../../../utils/number/budget-format.ts"

const { Text } = Typography

export interface ContractBreakdownSide {
  original: string
  included_change_requests: string
  current: string
}

interface ContractBreakdownProps {
  label: string
  side?: ContractBreakdownSide | null
}

/**
 * Original Contract → Included Change Requests → Current Contract Value.
 *
 * Shown only once the two ends differ: a project with no included Change
 * Request would otherwise carry three lines saying the same number.
 */
export function ContractBreakdown({ label, side }: ContractBreakdownProps) {
  if (!side) return null

  const original = Number(side.original)
  const current = Number(side.current)
  if (original === current) return null

  return (
    <Flex vertical className="mt-1">
      <Text type="secondary" className="text-xs">
        Original {label}: {budgetFormat(original)}
      </Text>
      <Text type="secondary" className="text-xs">
        Included Change Requests:{" "}
        {budgetFormat(Number(side.included_change_requests))}
      </Text>
      <Text type="secondary" className="text-xs">
        Current {label}: {budgetFormat(current)}
      </Text>
    </Flex>
  )
}
